module.exports = __webpack_public_path__ + "static/media/extreme.00fb5cdd.jpeg";